<template>
  <div class="mainContent">
    <QA :loading.sync="loading" :qidList="qidList"  :isEnd="isEnd" :selectedQidSmall="selectedQidSmall"></QA>
  </div>
</template>

<script>
import QA from '../components/Q&A.vue'
import { answerUpload } from '@/services/exam'
export default {
  components: {
    QA
  },
  data() {
    return {
      qidList: [{
        qid: 1,
        // title: '题目1',
        small: [
          {
            id: 1,
            title: '题目1',
            desc: ['1. 李华绘制了辣椒在中国的传播路线，最符合资料1说法的是（单选）'],
            durationTime: 100,
            stemContent: [
              {
                type: 'text',
                value: '红星中学的几位高一学生因为喜欢吃辣，希望围绕“辣椒”这一主题开展研究性学习。几位同学分别查阅资料，并开展交流研讨。请你帮助他们共同完成研学任务。'
              },
              {
                type: 'text',
                value: '为了了解辣椒在中国的传播过程，李华同学收集了“资料1”，绘制了辣椒在中国的传播路径（见图1），并给组内同学展示。'
              },
              {
                type: 'textArray',
                label: '资料1',
                value: [
                  { text: '一年生辣椒于 16 世纪 80 年代从日本传入中国，最早的传入地是浙江。以浙江为起点，向北经江苏传到山东。再以山东为中心，继续向河北、辽宁传播，向西传到了山西、河南、甘肃，形成华北传播链。沿长江西上，并以湖南为中心，向贵州、四川、云南等地传播，形成影响最大的长江传播路线。' },
                  { text: '[摘编自：邹学校等《辣椒传入中国的途径与传播路径》，《湖南农业大学学报(自然科学版)》2020年第46卷第6期]', type: 'noTextIndent' },
                  { img: require('@/assets/exam/ditu.png') },
                  { text: '图 1', textAlign: 'center' }
                ]
              },
              // {
              //   type: 'text',
              //   value: '[ 摘编自2020年《辣椒传入中国的途径与传播路径》]'
              // },
              // {
              //   type: 'img',
              //   value: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_630d876006f03/200431137.png'
              // },
            ],
            // showAnswer: false,
            askList: [{
              id: 1,
              type: 5,
              value: [
                {
                  type: 'text',
                  val: 'A. ①③',
                  clickStats: 'click_option_a#点击选项A',
                },
                {
                  type: 'text',
                  val: 'B. ①④',
                  clickStats: 'click_option_b#点击选项B',
                },
                {
                  type: 'text',
                  val: 'C. ②③',
                  clickStats: 'click_option_c#点击选项C',
                },
                {
                  type: 'text',
                  val: 'D. ③④',
                  clickStats: 'click_option_d#点击选项D',
                }]
            }]
          },
          {
            id: 2,
            title: '题目2',
            desc: ['2. 请你结合资料和所学内容，对张伟同学的观点及论据进行反驳。'],
            durationTime: 100,
            stemContent: [
              {
                type: 'text',
                value: '张伟同学的籍贯是四川，他说从小受家人影响，喜欢吃辣椒。为此，他曾经查阅资料2，认为中国人吃辣椒的传统应该非常久远，不可能是李华同学所说的始于16世纪。'
              },
              {
                type: 'textArray',
                label: '资料2',
                value: [{ text: '晋代常璩所著《华阳国志·蜀记》记载蜀人“尚滋味，好辛香”。' }]
              }
            ],
            askList: [{
              id: 1,
              type: 1
            }]
          }
        ]
      }, {
        qid: 2,
        // title: '题目2',
        small: [
          {
            id: 3,
            title: '题目3',
            desc: ['3. 请你说出影响人们喜食辣椒的因素，并结合实例进行分析。（结合所学或生活经历均可）'],
            durationTime: 100,
            stemContent: [
              {
                type: 'text',
                value: '张伟同学的籍贯是四川，他说从小受家人影响，喜欢吃辣椒。为此，他曾经查阅资料2，认为中国人吃辣椒的传统应该非常久远，不可能是李华同学所说的始于16世纪。'
              },
              {
                type: 'textArray',
                label: '资料2',
                value: [{ text: '晋代常璩所著《华阳国志·蜀记》记载蜀人“尚滋味，好辛香”。' }]
              }
            ],
            askList: [{
              id: 1,
              type: 1
            }]
          },
          {
            id: 4,
            title: '题目4',
            desc: ['4. 请你列出资料3与资料4矛盾的内容，并据此提出一个问题。'],
            durationTime: 100,
            stemContent: [
              {
                type: 'text',
                value: '为了探究人们喜食辣椒的原因，王雷同学收集了“资料3”和“资料4”。'
              },
              {
                type: 'textArray',
                label: '资料3',
                value: [
                  { text: '在中国，人们特别喜欢吃辣的地区包括四川等地。其与年平均接受太阳辐射热量低于110千卡的地区基本重合，同时它还与年日照时数在1800小时以内、冬季1月份相对湿度在70%以上的地区重合，冬季冷湿、日照少、雾气大，是这些地区食辣最重要的地理环境背景。' },
                  { text: '[摘编自：张茜《川人食辣问题的文化阐释》，《中国调味品》2016年第41卷第10期]', type: 'noTextIndent' }
                ]
              },
              {
                type: 'textArray',
                label: '资料4',
                value: [
                  { text: '以全球视野来看，印度、墨西哥、东南亚这些日常食用辣椒比较多的地区，并非日照较少的地区，反而是阳光充沛、气温很高的地区。而北欧、加拿大这些日照不足、气温很低的地区，食用辣椒较少。' },
                  { text: '[摘编自：曹雨《中国食辣史》，2019年]', type: 'noTextIndent' }
                ]
              }
            ],
            askList: [{
              id: 1,
              type: 1
            }]
          }
        ]
      }, {
        qid: 3,
        // title: '题目4',
        small: [
          {
            id: 5,
            title: '题目5',
            durationTime: 100,
            hasDialog: true,
            desc: ['5. 与“辣椒种植面积”相比，说明“湘菜、川菜地域偏好指数”作为衡量辣椒在不同区域受欢迎程度指标的优势和不足。'],
            stemContent: [
              {
                type: 'text',
                value: '韩梅同学认为伴随辣椒的传播过程，虽然不同区域有不同的喜食辣椒的原因，但还需要研制一个指标，衡量辣椒在不同区域的受欢迎程度，她收集了“资料5”和“资料6”'
              },
              {
                type: 'textArray',
                label: '资料5',
                value: [
                  { text: '近年，贵州、河南、云南、江苏、湖南、山东、广东、四川、辽宁、广西、河北这11 省区的辣椒种植面积超过7万公顷。其中，河南的辣椒种植面积超过24万公顷，贵州的辣椒种植面积超过30万公顷。' },
                  { text: '[摘编自：邹学校等《辣椒在中国的传播与产业发展》，《园艺学报》2020年第47卷第9期]', type: 'noTextIndent' }
                ]
              },
              {
                type: 'textArray',
                label: '资料6',
                value: [
                  { text: '湘菜、川菜地域偏好指数是指某地级市中湘菜馆、川菜馆在该地级市的总数分别与该地级市中餐馆总数之比。将300多个地级市的偏好指数从小到大排序，然后根据数量等分为7类，最后基于此分类构建湘菜、川菜地域偏好指数地图。图2为湘菜、川菜地域偏好指数分布图。餐馆数据源为 2018 年的高德地图餐饮服务类数据，其提供了餐馆的地理位置和中餐馆的川菜、湘菜等分类。' },
                  { img: require('@/assets/exam/28.png'), legend: '<div class="datum-6-legend"><span>湘菜地域偏好指数分布</span><span>川菜地域偏好指数分布</span></div>' },
                  { text: '注：香港特别行政区、澳门特别行政区、台湾省的数据暂无。' },
                  { text: '图 2', textAlign: 'center' },
                  { text: '[摘编自：顾秋实等《中国传统八大菜系的地理分布及其扩散效应——基于大数据视角的实证分析》，《浙江学刊》2019年第5期]', type: 'noTextIndent' },
                ]
              }
            ],
            askList: [
              {
                id: 1,
                type: 1,
                isReview: true,
                title: '',
              },
              // {
              //   id: 2,
              //   title: '“湘菜、川菜地域偏好指数”作为指标的优势和不足:',
              //   type: 1
              // }
            ]
          },
          {
            id: 6,
            title: '题目6',
            durationTime: 100,
            hasDialog: true,
            desc: ['6. 为了了解辣椒受欢迎程度是否会随着川菜的“变革”而增加，请你设计一个调查方案（包括调查内容和指标、调查方法、调查过程等），并说明这样设计的理由。'],
            stemContent: [
              {
                type: 'text',
                value: '周国同学猜想随着川菜在传播过程中的“变革”，人们会食用更多含有辣椒的菜品，辣椒在不同区域的受欢迎程度可能会增加。为此，他收集了“资料7”，证明他的观点。'
              },
              {
                type: 'textArray',
                label: '资料7',
                value: [
                  { text: '为了适应不同地区消费者的嗜辣程度差异，川菜在传播过程中出现“变革”。例如，由于气候、人文因素的特点，大连川菜出现麻辣程度任由顾客选择，新增川菜海鲜等现象。' },
                  { text: '[摘编自：蔡宁伟《川菜的传承和发展——以大连地区川菜饭店的本地化和多元化为例》，《饮食文化研究》2005年第4期]', type: 'noTextIndent' }
                ]
              }
            ],
            askList: [
              {
                id: 1,
                isReview: true,
                title: '调查方案：',
                type: 1,
                statsVar: '1'
              },
              {
                id: 2,
                title: '理由：',
                type: 1,
                statsVar: '2'
              }
            ]
          }
        ]
      }, {
        qid: 4,
        // title: '题目5',
        small: [
          {
            id: 7,
            title: '题目7',
            durationTime: 100,
            desc: ['7. 请你对照“研学调查方案评价量规”，修改你的调查方案，并说明修改的原因。'],
            stemContent: [
              {
                type: 'text',
                value: '该研究性学习小组的指导教师为小组同学提供了一份研学调查方案评价量规，如表1所示。'
              },
              {
                type: 'img',
                isBig: true,
                value: require('@/assets/exam/27.png')
              }
            ],
            askList: [
              {
                id: 1,
                type: 1,
                richText: true
              }
            ]
          }
        ]
      }],
      isEnd: false,
      loading: false,
      selectedQidSmall: 1
    }
  },
  created() {

  },
  methods: {
    async next(sonData, currentQSmall, type) {
      const data = Object.assign({
        exam_id: 1,
        exam_num: '1_' + currentQSmall,
        subject_id: 7,
        subject_name: '辣椒',
        pic_info: '答案',
        status: 2
      }, sonData)
      if (!this.isEnd) {
        const res = await answerUpload(data)
        this.loading = false
        if (!res || res.code != '200') {
          this.$message({ type: 'error', message: res ? res.msg || res.message : '网络连接失败！' })
          return
        }
      }
      if (type === 'overTime' || this.isEnd) {
        this.nextPage(type === 'overTime')
      } else if (currentQSmall === 7) {
        this.selectedQidSmall = 7
        this.isEnd = true
      } else {
        this.selectedQidSmall = currentQSmall + 1
      }
      this.$forceUpdate()
    },
    nextPage(isEnd) {
      // setTimeout(() => {
      const examArr = JSON.parse(sessionStorage.currentExamGroup).exam
      if (isEnd) {
        this.$message.info('测评结束')
        if (examArr.length === 1) {
          this.$router.push({
            name: 'examLogin',
            query: {
              subject: 'criticismSteer',
              type: 'public',
              isEnd: true
            }
          })
        } else {
          this.$router.push({
            name: 'examLogin',
            query: {
              isEnd: true,
              subject: sessionStorage.subjectName,
              time: JSON.parse(sessionStorage.currentExamGroup).name.includes('下午') ? 'pm' : undefined
            }
          })
        }
      } else {
        sessionStorage.currentExamIndex = Number(sessionStorage.currentExamIndex) + 1
        this.$router.push({
          name: examArr[sessionStorage.currentExamIndex]
        })
      }
    }
  }
};
</script>
<style>
.el-message-box__message p, .el-button .el-button--default .el-button--small span{
  font-size: 16px;
}
.el-radio__input,
.el-checkbox__input {
  vertical-align: initial;
}
</style>
<style lang="less">
.mainContent {
  height: 100%;
}
.datum-6-legend {
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  gap: 30px;
  margin-top: 6px;
  > span {
    font-size: 16px;
    font-weight: 500;
  }
  > span:first-child {
    justify-self: flex-end;
  }
}
</style>
